// Thin wrapper around gtag. The loader is only injected into the prod shell
// (see src/index.ts -> injectAnalytics), so window.gtag is undefined in dev and
// the optional chaining short-circuits to a no-op.

type GtagParams = Record<string, unknown>;

export function trackEvent(name: string, params?: GtagParams) {
  window.gtag?.("event", name, params ?? {});
}

// Fired on a completed registration. Marked as a conversion in GA4 and imported
// into Google Ads so the campaign can optimize toward real signups.
export function trackSignup(method: "email" | "github" | "google") {
  trackEvent("sign_up", { method });
}

export type CtaLocation =
  | "header"
  | "hero"
  | "mid"
  | "footer"
  | "sticky"
  | "playground"
  | "sub_nav";

// Fires when a visitor clicks any "Start free" / "Sign in" CTA on a public page.
// Combined with `sign_up`, lets us see drop-off between intent and completion.
export function trackCtaClick(
  location: CtaLocation,
  extra?: { target?: "register" | "login"; surface?: string },
) {
  trackEvent("cta_click", { location, ...extra });
}

export function trackRegisterView() {
  trackEvent("register_view");
}

export function trackRegisterSubmitAttempt(method: "email" | "github" | "google") {
  trackEvent("register_submit_attempt", { method });
}

export function trackRegisterError(
  method: "email" | "github" | "google",
  errorCode?: string,
) {
  trackEvent("register_error", { method, error_code: errorCode ?? "unknown" });
}

export type PlaygroundInteraction =
  | "mint"
  | "ws_connected"
  | "request_seen"
  | "url_copied";

export function trackPlaygroundInteraction(kind: PlaygroundInteraction) {
  trackEvent("playground_interaction", { kind });
}

export function trackScrollDepth(percent: 25 | 50 | 75 | 100) {
  trackEvent("scroll_depth", { percent });
}
